import { GlobalContext, Section } from "../lib/Root";
import { useContext, useEffect } from "react";

export default function AccountDelete() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Delete"; }, []);

	return <Section center>
		<p>Are you sure?</p>
		<input type="button" value="Stay Forever" />
	</Section>;
}